module.exports = __webpack_public_path__ + "static/media/close-cross-gray.a88817a0.svg";